import { render, staticRenderFns } from "./consume.vue?vue&type=template&id=a951033e&scoped=true"
import script from "./consume.vue?vue&type=script&lang=js"
export * from "./consume.vue?vue&type=script&lang=js"
import style0 from "./consume.vue?vue&type=style&index=0&id=a951033e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a951033e",
  null
  
)

export default component.exports